import { ActionIcon, Group, Input, Text } from "@mantine/core";
import { Dropzone } from "@mantine/dropzone";
import React from "react";
import { File, X } from "react-feather";

export type FileUploadTexts = {
  waiting: string;
  rejected: string;
  accepted: string;
};

export type FileUploadSuccessComponentProps = {
  clearFile: () => void;
  fileName: string;
};

export function FileUploadSuccessComponent({
  clearFile,
  fileName,
}: FileUploadSuccessComponentProps) {
  return (
    <div className="p-2 rounded border border-gray-300 mb-2 flex justify-between items-center">
      {fileName}
      <ActionIcon onClick={clearFile}>
        <X size={20} />
      </ActionIcon>
    </div>
  );
}

function FileUploadField({
  label,
  fileTypes,
  maxSize = 30 * 1024 ** 2,
  texts,
  children,
  successComponent: SuccessComponent = FileUploadSuccessComponent,
  required = false,

  file,
  setFile,
  hasError,
}: {
  label: string;
  fileTypes: string[];
  maxSize?: number;
  texts: FileUploadTexts;
  children?: React.ReactNode;
  successComponent?: React.ComponentType<FileUploadSuccessComponentProps>;
  required?: boolean;

  file?: File;
  setFile: (file?: File) => void;
  hasError: boolean;
}) {
  return (
    <Input.Wrapper label={label} mt="lg" required={required}>
      <div>
        {file ? (
          <SuccessComponent
            clearFile={() => setFile(undefined)}
            fileName={file.name}
          />
        ) : (
          <Dropzone
            onDrop={(files) => {
              console.log(files);
              setFile(files[0]);
            }}
            className=""
            radius="md"
            maxSize={maxSize}
            accept={fileTypes}
          >
            <div style={{ pointerEvents: "none" }}>
              <Group position="center">
                <File size={30} />
              </Group>
              <Text align="center" weight={700} size="lg" mt="xl">
                <Dropzone.Accept>{texts.waiting}</Dropzone.Accept>
                <Dropzone.Reject>{texts.rejected}</Dropzone.Reject>
                <Dropzone.Idle>Laden Sie Ihre Datei hoch</Dropzone.Idle>
              </Text>
              <Text align="center" size="sm" mt="xs" color="dimmed">
                {children}
              </Text>
            </div>
          </Dropzone>
        )}

        {hasError && (
          <Text size="sm" mt="xs" color="red">
            Bitte laden Sie eine Datei hoch
          </Text>
        )}
      </div>
    </Input.Wrapper>
  );
}

export default FileUploadField;
